import React, { useEffect, useState } from "react";
import { CarouselItem } from "../Carousel/CarouselItem";
import { BreadCrumbItem } from "../ProductDetailPageResult";
import TallCarouselNoCartButton from "../TallCarouselNoCartButton";
import fetchRelatedItemsAI from "./fetchRelatedItemsAI";
interface RelatedItemsCarouselProps {
  itemNumber: string;
  itemTitle: string;
  categoryId: string;
  categoryTitle: string;
  breadcrumbs: BreadCrumbItem[];
}
const RelatedItemsCarousel = ({
  itemNumber,
  itemTitle,
  categoryId,
  categoryTitle,
  breadcrumbs
}: RelatedItemsCarouselProps) => {
  const [items, setItems] = useState<CarouselItem[]>([]);
  useEffect(() => {
    const fetchAndSetRelatedItems = async () => {
      const breadcrumbNames = breadcrumbs.map(breadcrumb => breadcrumb.displayText) || [];
      const response = await fetchRelatedItemsAI(itemNumber, itemTitle, categoryId, categoryTitle, breadcrumbNames);
      if (!response.isError && response.value.length > 0) {
        setItems(response.value);
      }
    };
    fetchAndSetRelatedItems();
  }, [itemNumber, itemTitle, categoryId, categoryTitle, breadcrumbs]);
  if (items.length === 0) return null;
  return <TallCarouselNoCartButton key={`relatedItemsTallCarousel-${itemNumber}`} id="related-items-carousel" heading="Related Items" carouselItems={items} gtmCarouselName="Related Items" data-sentry-element="TallCarouselNoCartButton" data-sentry-component="RelatedItemsCarousel" data-sentry-source-file="RelatedItemsCarousel.tsx" />;
};
export default RelatedItemsCarousel;